import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SNAPDetails from '../../subdepartmentdetails/SNAP'


function SNAP() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Supplemental Nutrition Assistance Program (SNAP) || Family and Children Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Family Community Services"
            title="Supplemental Nutrition Assistance Program (SNAP)"
            subtitledown="Department of Family & Children Services"
           />
            <SNAPDetails/>
        </div>
    </>
  )
}

export default SNAP



